import React, { useState } from "react";
import "../../../assets/css/admin/Categories.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const SEED_CATEGORIES = [
  { id: 1, name: "Web Development", coursesCount: 24, status: "Active" },
  { id: 2, name: "Mobile Development", coursesCount: 18, status: "Active" },
  { id: 3, name: "Data Science", coursesCount: 15, status: "Active" },
  { id: 4, name: "UI/UX Design", coursesCount: 11, status: "Active" },
  { id: 5, name: "Cloud Computing", coursesCount: 9, status: "Inactive" },
  { id: 6, name: "Cybersecurity", coursesCount: 7, status: "Active" },
  { id: 7, name: "Machine Learning", coursesCount: 13, status: "Active" },
  { id: 8, name: "DevOps", coursesCount: 6, status: "Inactive" },
];

let nextId = 9;

function getInitials(name) {
  const words = name.trim().split(/\s+/);
  return words.length > 1
    ? (words[0][0] + words[1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();
}

const IconFolder = () => (
  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
    <path
      d="M3 5C3 3.895 3.895 3 5 3H9.586C9.851 3 10.105 3.105 10.293 3.293L11.707 4.707C11.895 4.895 12.149 5 12.414 5H19C20.105 5 21 5.895 21 7V19C21 20.105 20.105 21 19 21H5C3.895 21 3 20.105 3 19V5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
    <path
      d="M22 11.08V12C21.999 14.156 21.3 16.255 20.009 17.982C18.718 19.709 16.903 20.972 14.835 21.584C12.767 22.195 10.557 22.122 8.534 21.375C6.512 20.627 4.785 19.246 3.611 17.437C2.437 15.628 1.88 13.488 2.022 11.336C2.164 9.185 2.997 7.136 4.398 5.497C5.799 3.858 7.693 2.715 9.796 2.24C11.9 1.765 14.1 1.982 16.07 2.86"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 4L12 14.01L9 11.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconBan = () => (
  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M4.93 4.93L19.07 19.07"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const IconBook = () => (
  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
    <path
      d="M2 3H8C9.06 3 10.078 3.421 10.828 4.172C11.579 4.922 12 5.939 12 7V21C12 20.204 11.684 19.441 11.121 18.879C10.559 18.316 9.796 18 9 18H2V3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 3H16C14.939 3 13.922 3.421 13.172 4.172C12.421 4.922 12 5.939 12 7V21C12 20.204 12.316 19.441 12.879 18.879C13.441 18.316 14.204 18 15 18H22V3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconList = () => (
  <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
    <path
      d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconPlus = () => (
  <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
    <path
      d="M12 5V19M5 12H19"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconEdit = () => (
  <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
    <path
      d="M11 4H4C3.47 4 2.961 4.211 2.586 4.586C2.211 4.961 2 5.47 2 6V20C2 20.53 2.211 21.039 2.586 21.414C2.961 21.789 3.47 22 4 22H18C18.53 22 19.039 21.789 19.414 21.414C19.789 21.039 20 20.53 20 20V13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 2.5C18.898 2.102 19.449 1.879 20.021 1.879C20.593 1.879 21.144 2.102 21.542 2.5C21.94 2.898 22.163 3.449 22.163 4.021C22.163 4.593 21.94 5.144 21.542 5.542L12 15L8 16L9 12L18.5 2.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconDelete = () => (
  <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
    <path
      d="M3 6H5H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 6L18.117 19.14C18.051 20.178 17.187 21 16.147 21H7.853C6.813 21 5.949 20.178 5.883 19.14L5 6M10 11V17M14 11V17M9 6V4C9 3.447 9.448 3 10 3H14C14.552 3 15 3.447 15 4V6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconClose = () => (
  <svg viewBox="0 0 24 24" fill="none" width="15" height="15">
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconTick = () => (
  <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
    <path
      d="M20 6L9 17L4 12"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Categories = () => {
  const [categories, setCategories] = useState(SEED_CATEGORIES);

  const [addName, setAddName] = useState("");
  const [addStatus, setAddStatus] = useState("Active");
  const [addError, setAddError] = useState("");

  const [editTarget, setEditTarget] = useState(null);
  const [editName, setEditName] = useState("");
  const [editStatus, setEditStatus] = useState("Active");
  const [editError, setEditError] = useState("");

  const [deleteTarget, setDeleteTarget] = useState(null);

  const activeCount = categories.filter((c) => c.status === "Active").length;
  const inactiveCount = categories.filter(
    (c) => c.status === "Inactive",
  ).length;
  const totalCourses = categories.reduce((sum, c) => sum + c.coursesCount, 0);

  function handleAdd(e) {
    e.preventDefault();
    const trimmed = addName.trim();
    if (!trimmed) {
      setAddError("Category name is required.");
      return;
    }
    if (
      categories.some((c) => c.name.toLowerCase() === trimmed.toLowerCase())
    ) {
      setAddError("A category with this name already exists.");
      return;
    }
    setCategories((prev) => [
      ...prev,
      { id: nextId++, name: trimmed, coursesCount: 0, status: addStatus },
    ]);
    setAddName("");
    setAddStatus("Active");
    setAddError("");
  }

  function openEdit(cat) {
    setEditTarget(cat);
    setEditName(cat.name);
    setEditStatus(cat.status);
    setEditError("");
  }
  function closeEdit() {
    setEditTarget(null);
    setEditError("");
  }

  function handleUpdate(e) {
    e.preventDefault();
    const trimmed = editName.trim();
    if (!trimmed) {
      setEditError("Category name is required.");
      return;
    }
    if (
      categories.some(
        (c) =>
          c.name.toLowerCase() === trimmed.toLowerCase() &&
          c.id !== editTarget.id,
      )
    ) {
      setEditError("A category with this name already exists.");
      return;
    }
    setCategories((prev) =>
      prev.map((c) =>
        c.id === editTarget.id
          ? { ...c, name: trimmed, status: editStatus }
          : c,
      ),
    );
    closeEdit();
  }

  function handleDelete() {
    setCategories((prev) => prev.filter((c) => c.id !== deleteTarget.id));
    setDeleteTarget(null);
  }

  function toggleStatus(id) {
    setCategories((prev) =>
      prev.map((c) =>
        c.id === id
          ? { ...c, status: c.status === "Active" ? "Inactive" : "Active" }
          : c,
      ),
    );
  }

  return (
    <AdminLayout>
      <div className="cat-page">
        {/* Top Bar */}
        <div className="cat-topbar">
          <div>
            <h2 className="cat-page-title">Category Management</h2>
            <p className="cat-page-desc">
              Organise your course catalog by category
            </p>
          </div>
        </div>

        {/* Stat Cards */}
        <div className="cat-stats-grid">
          <div className="cat-stat-card">
            <div className="cat-stat-card-top">
              <div className="cat-stat-icon">
                <IconFolder />
              </div>
            </div>
            <div className="cat-stat-number">{categories.length}</div>
            <div className="cat-stat-title">Total Categories</div>
          </div>
          <div className="cat-stat-card">
            <div className="cat-stat-card-top">
              <div className="cat-stat-icon">
                <IconCheck />
              </div>
            </div>
            <div className="cat-stat-number">{activeCount}</div>
            <div className="cat-stat-title">Active</div>
          </div>
          <div className="cat-stat-card">
            <div className="cat-stat-card-top">
              <div className="cat-stat-icon">
                <IconBan />
              </div>
            </div>
            <div className="cat-stat-number">{inactiveCount}</div>
            <div className="cat-stat-title">Inactive</div>
          </div>
          <div className="cat-stat-card">
            <div className="cat-stat-card-top">
              <div className="cat-stat-icon">
                <IconBook />
              </div>
            </div>
            <div className="cat-stat-number">{totalCourses}</div>
            <div className="cat-stat-title">Total Courses</div>
          </div>
        </div>

        {/* Add Category */}
        <div className="cat-card">
          <div className="cat-card-header">
            <div className="cat-card-header-icon">
              <IconPlus />
            </div>
            <h3 className="cat-card-title">Add New Category</h3>
          </div>
          <form className="cat-add-form" onSubmit={handleAdd} noValidate>
            <div className="cat-form-row">
              <div className="cat-form-group">
                <label className="cat-label" htmlFor="cat-name-input">
                  Category Name <span className="cat-required">*</span>
                </label>
                <input
                  id="cat-name-input"
                  type="text"
                  className={`cat-input${addError ? " cat-input--error" : ""}`}
                  placeholder="e.g. Artificial Intelligence"
                  value={addName}
                  onChange={(e) => {
                    setAddName(e.target.value);
                    setAddError("");
                  }}
                  maxLength={80}
                />
                {addError && (
                  <span className="cat-field-error">{addError}</span>
                )}
              </div>
              <div className="cat-form-group cat-form-group--sm">
                <label className="cat-label" htmlFor="cat-status-select">
                  Status
                </label>
                <select
                  id="cat-status-select"
                  className="cat-select"
                  value={addStatus}
                  onChange={(e) => setAddStatus(e.target.value)}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
              <div className="cat-form-group cat-form-group--btn">
                <button type="submit" className="cat-btn cat-btn--primary">
                  <IconPlus /> Add Category
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* Table */}
        <div className="cat-card">
          <div className="cat-card-header cat-card-header--between">
            <div className="cat-card-header-left">
              <div className="cat-card-header-icon">
                <IconList />
              </div>
              <h3 className="cat-card-title">All Categories</h3>
            </div>
            <span className="cat-table-count">{categories.length} entries</span>
          </div>

          <div className="cat-table-wrapper">
            {/* ✅ colgroup REMOVED — widths ab nth-child CSS se control hongi */}
            <table className="cat-table">
              <thead>
                <tr>
                  <th>#ID</th>
                  <th>Category Name</th>
                  <th className="cat-th--center">Courses</th>
                  <th className="cat-th--center">Status</th>
                  <th className="cat-th--center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((cat) => (
                  <tr key={cat.id}>
                    <td>
                      <span className="cat-id-badge">
                        {String(cat.id).padStart(2, "0")}
                      </span>
                    </td>

                    <td>
                      <div className="cat-name-cell">
                        <div className="cat-name-avatar">
                          {getInitials(cat.name)}
                        </div>
                        <span className="cat-name-text">{cat.name}</span>
                      </div>
                    </td>

                    <td className="cat-td--center">
                      <span className="cat-courses-pill">
                        {cat.coursesCount}
                      </span>
                    </td>

                    <td className="cat-td--center">
                      <button
                        className={`cat-status-toggle cat-status-toggle--${cat.status === "Active" ? "active" : "inactive"}`}
                        onClick={() => toggleStatus(cat.id)}
                        title={`Click to set ${cat.status === "Active" ? "Inactive" : "Active"}`}
                      >
                        {cat.status}
                      </button>
                    </td>

                    <td className="cat-td--center">
                      <div className="cat-actions">
                        <button
                          className="cat-action-btn cat-action-btn--edit"
                          onClick={() => openEdit(cat)}
                        >
                          <IconEdit /> Edit
                        </button>
                        <button
                          className="cat-action-btn cat-action-btn--delete"
                          onClick={() => setDeleteTarget(cat)}
                        >
                          <IconDelete /> Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

                {categories.length === 0 && (
                  <tr>
                    <td colSpan={5} className="cat-empty">
                      <div className="cat-empty-inner">
                        <IconFolder />
                        <p>No categories yet. Add one above.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Edit Modal */}
        {editTarget && (
          <div
            className="cat-modal-overlay"
            onClick={(e) => {
              if (e.target === e.currentTarget) closeEdit();
            }}
          >
            <div
              className="cat-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="edit-modal-title"
            >
              <div className="cat-modal-header">
                <h3 className="cat-modal-title" id="edit-modal-title">
                  Edit Category
                </h3>
                <button
                  className="cat-modal-close"
                  onClick={closeEdit}
                  aria-label="Close"
                >
                  <IconClose />
                </button>
              </div>
              <form onSubmit={handleUpdate} noValidate>
                <div className="cat-modal-body">
                  <div className="cat-form-group">
                    <label className="cat-label" htmlFor="edit-name-input">
                      Category Name <span className="cat-required">*</span>
                    </label>
                    <input
                      id="edit-name-input"
                      type="text"
                      className={`cat-input${editError ? " cat-input--error" : ""}`}
                      value={editName}
                      onChange={(e) => {
                        setEditName(e.target.value);
                        setEditError("");
                      }}
                      maxLength={80}
                      autoFocus
                    />
                    {editError && (
                      <span className="cat-field-error">{editError}</span>
                    )}
                  </div>
                  <div className="cat-form-group">
                    <label className="cat-label" htmlFor="edit-status-select">
                      Status
                    </label>
                    <select
                      id="edit-status-select"
                      className="cat-select"
                      value={editStatus}
                      onChange={(e) => setEditStatus(e.target.value)}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
                <div className="cat-modal-footer">
                  <button
                    type="button"
                    className="cat-btn cat-btn--ghost"
                    onClick={closeEdit}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="cat-btn cat-btn--primary">
                    <IconTick /> Update Category
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Delete Modal */}
        {deleteTarget && (
          <div
            className="cat-modal-overlay"
            onClick={(e) => {
              if (e.target === e.currentTarget) setDeleteTarget(null);
            }}
          >
            <div
              className="cat-modal cat-modal--sm"
              role="alertdialog"
              aria-modal="true"
            >
              <div className="cat-modal-header">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                  }}
                >
                  <div className="cat-delete-icon-wrap">
                    <IconDelete />
                  </div>
                  <h3 className="cat-modal-title">Delete Category</h3>
                </div>
                <button
                  className="cat-modal-close"
                  onClick={() => setDeleteTarget(null)}
                  aria-label="Close"
                >
                  <IconClose />
                </button>
              </div>
              <div className="cat-modal-body">
                <p className="cat-delete-msg">
                  Are you sure you want to delete{" "}
                  <strong>"{deleteTarget.name}"</strong>?
                  {deleteTarget.coursesCount > 0 && (
                    <>
                      {" "}
                      This category has{" "}
                      <strong>
                        {deleteTarget.coursesCount} course
                        {deleteTarget.coursesCount !== 1 ? "s" : ""}
                      </strong>{" "}
                      linked to it.
                    </>
                  )}{" "}
                  This action cannot be undone.
                </p>
              </div>
              <div className="cat-modal-footer">
                <button
                  className="cat-btn cat-btn--ghost"
                  onClick={() => setDeleteTarget(null)}
                >
                  Cancel
                </button>
                <button
                  className="cat-btn cat-btn--danger"
                  onClick={handleDelete}
                >
                  <IconDelete /> Yes, Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Categories;